module.exports = __webpack_public_path__ + "img/whathot_s02.0ae34b93.png";